module.exports = "https://la-static.vkplay.ru/promo/newstart/img/paladin.92850b40.png";